/* oz-cart.js — Ozzi subscription controls for the cart page and the pop-up drawer.
 *
 *  - Frequency dropdown (.oz-freq__select): change a subscription line's interval.
 *  - Subscribe button ([data-oz-sub-add]): put a one-time line on the plan.
 *  - Remove subscription ([data-oz-sub-remove]): take a line back to one-time.
 *  - Free sample cleanup: drop the sample pack once nothing qualifies for it.
 *  - Free gift cleanup: drop the promo's free Capsules bottle once fewer than 2 bags remain.
 *
 *  Each is one /cart/change.js call on that single line. On the cart page we reload;
 *  in the drawer we re-render the drawer in place so it never closes. Guarded so it
 *  only initialises once even if the script is included on more than one surface.
 */
(function () {
  'use strict';
  if (window.__ozCartInit) return;
  window.__ozCartInit = true;

  function root() {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
  }

  function inDrawer(el) {
    return !!(el.closest && el.closest('cart-drawer'));
  }

  function postChange(body) {
    return fetch(root() + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/change.js responded ' + r.status);
      return r.json();
    });
  }

  // Re-render the drawer contents from the cart-drawer section without reloading.
  function refreshDrawer() {
    return fetch(root() + '/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // .ozd-ship (free-ship progress bar) sits outside cart-drawer-items but its copy/fill depend
        // on cart state (a subscription always ships free), so refresh it too — otherwise removing or
        // adding a subscription leaves the bar stale.
        ['cart-drawer-items', '.cart-drawer__footer', '.ozd-ship'].forEach(function (sel) {
          var target = document.querySelector(sel);
          var source = doc.querySelector(sel);
          if (target && source) target.replaceWith(source);
        });
      });
  }

  // planId falsy => strip the plan (back to one-time).
  function applyPlan(el, planId) {
    var lineKey = el.getAttribute('data-line-key');
    if (!lineKey) return;
    var qty = parseInt(el.getAttribute('data-qty'), 10);
    if (!qty || qty < 1) qty = 1;
    var drawer = inDrawer(el);

    el.disabled = true;
    if (el.tagName === 'SELECT') el.style.opacity = '0.55';

    var body = { id: lineKey, quantity: qty, selling_plan: planId ? Number(planId) : null };

    postChange(body)
      .then(function () {
        if (drawer) return refreshDrawer();
        window.location.reload();
      })
      .catch(function (error) {
        console.error('[oz-cart] plan change failed', error);
        el.disabled = false;
        if (el.tagName === 'SELECT') el.style.opacity = '';
        window.alert('Sorry, we could not update that. Please try again.');
      });
  }

  // Frequency dropdown. Capture phase + stopPropagation so Dawn's cart-items change
  // handler never treats the plan id as a quantity.
  document.addEventListener(
    'change',
    function (event) {
      var select = event.target.closest ? event.target.closest('.oz-freq__select') : null;
      if (!select) return;
      event.stopPropagation();
      var selected = select.querySelector('option[selected]');
      var serverValue = selected ? selected.value : select.getAttribute('data-current');
      if (select.value === serverValue) return;
      applyPlan(select, select.value);
    },
    true
  );

  // Subscribe / remove-subscription buttons.
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var add = event.target.closest('[data-oz-sub-add]');
    if (add) {
      event.preventDefault();
      applyPlan(add, add.getAttribute('data-plan'));
      return;
    }
    var remove = event.target.closest('[data-oz-sub-remove]');
    if (remove) {
      event.preventDefault();
      applyPlan(remove, null);
    }
  });

  /* ---------- free sample pack cleanup ----------
   * The pack only exists alongside a qualifying purchase. The builder already drops it when its
   * own box empties, but that only runs on pages the builder is on. Remove the last bag from the
   * cart page or the drawer and the freebie would be stranded, and a sample-only order is exactly
   * what we don't want to ship.
   */
  var SAMPLE_ID = 45288442331335;
  var QUALIFYING_IDS = [
    45944714887367, 45944714952903, 45944777998535, 45944714920135, 45944714854599, // Crave Crusher v2
    68012391923911, 68012391956679, // Crave Crusher v2 pre-order twins (Watermelon Strawberry, Cherry Limeade), 2026-10-23
    46177427226823                                                                  // Crave Crusher Capsules
  ];

  // The three clean-ups below share one shape, for the checkout fix-up at the foot of this file:
  // each works from the cart it is handed (a buy button on its way to checkout has just read it)
  // or reads its own, hands back its run while one is in flight, and resolves true when it wrote
  // to the cart.
  function cartFor(cart) {
    if (cart) return Promise.resolve(cart);
    return fetch(root() + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  var pruning = null;
  function pruneOrphanSample(given) {
    if (pruning) return pruning;
    var wrote = false;
    pruning = cartFor(given)
      .then(function (cart) {
        var sample = null;
        var qualifies = false;
        (cart.items || []).forEach(function (line) {
          var id = line.variant_id || line.id;
          if (id === SAMPLE_ID) sample = line;
          else if (QUALIFYING_IDS.indexOf(id) !== -1 || earnsSample(line)) qualifies = true;
        });
        if (!sample || qualifies) return null;

        wrote = true;
        return postChange({ id: String(SAMPLE_ID), quantity: 0 }).then(function () {
          if (leaving) return;
          // Removing it ourselves publishes nothing, so refresh whichever cart UI is on screen.
          if (document.querySelector('cart-items')) { window.location.reload(); return; }
          if (document.querySelector('cart-drawer')) return refreshDrawer();
        });
      })
      .catch(function (error) {
        // Never block the cart over a cleanup pass.
        console.error('[oz-cart] sample cleanup failed', error);
      })
      .then(function () { pruning = null; return wrote; });
    return pruning;
  }

  /* ---------- promo bottle cleanup (Buy 2 bags, get Capsules free) ----------
   * The bundle builder adds the free bottle at 2+ bags and takes it out below that, but only on
   * pages the builder is on, and only for changes it hears about. Remove a bag from the drawer on
   * any other page, or on the cart page, and the bottle would stay in a 1-bag cart. Shopify's
   * discount ($55 off the Free Gift product, once per order) has NO bag condition, so that cart
   * would check out with a free bottle. It also removes a bottle that is no longer free (the
   * discount ended, or Shopify did not apply it), the same rule the builder follows. This only
   * ever REMOVES the bottle; adding it stays the builder's job.
   * HAND-MIRRORED from PROMO in ozzi-builder.js: the Free Gift product, the drink product whose
   * bags count (every flavour and plan), and the 2-bag threshold.
   */
  var GIFT_PRODUCT_ID = 15379692781767;   // Crave Crusher Capsules (Free Gift), unlisted
  var DRINK_PRODUCT_ID = 8571708604615;   // Crave Crusher
  var GIFT_MIN_BAGS = 2;

  function isGiftLine(line) {
    return line.product_id === GIFT_PRODUCT_ID || !!(line.properties && line.properties._gift);
  }

  var giftPruning = null;
  function pruneOrphanGift(given) {
    if (giftPruning) return giftPruning;
    var wrote = false;
    giftPruning = cartFor(given)
      .then(function (cart) {
        var gifts = [];
        var bags = 0;
        var priced = false;
        (cart.items || []).forEach(function (line) {
          if (isGiftLine(line)) {
            gifts.push(line);
            if (line.final_line_price > 0) priced = true;
          } else if (line.product_id === DRINK_PRODUCT_ID) {
            bags += line.quantity;
          }
        });
        if (!gifts.length || (bags >= GIFT_MIN_BAGS && !priced)) return null;

        wrote = true;
        var chain = Promise.resolve();
        gifts.forEach(function (line) {
          chain = chain.then(function () { return postChange({ id: line.key, quantity: 0 }); });
        });
        return chain.then(function () {
          if (leaving) return;
          // Same as the sample: our own removal publishes nothing, so refresh the cart UI on screen.
          if (document.querySelector('cart-items')) { window.location.reload(); return; }
          if (document.querySelector('cart-drawer')) return refreshDrawer();
        });
      })
      .catch(function (error) {
        console.error('[oz-cart] free gift cleanup failed', error);
      })
      .then(function () { giftPruning = null; return wrote; });
    return giftPruning;
  }


  /* ---------- capsule bundle gifts (3-month: 1 drink bag [+ sample pack]; 6-month: drink bag + BIOMEnd; starter: sample pack) ----------
   * The capsules page adds unlisted "(Free Gift)" products next to a 3- or 6-month capsule bundle;
   * the "Capsule bundle free gifts" automatic discount zeroes them with no condition of its own,
   * so this is what ties them to the bundle. It trims free drink bags to the number of 3/6-month
   * bundles in the cart, BIOMEnd to the number of 6-month bundles, and drops any gift that is not
   * actually free. It only ever REMOVES; adding stays with sections/ozzi-capsules-v2.liquid.
   * Same client-side limit as the sample cap: a /checkout permalink skips it.
   */
  var CAPS_3M = 67806784225479, CAPS_6M = 67806784258247;
  var CAPS_V1 = 46177427226823;                                      // Crave Crusher Capsules (original formula), single variant          // Natural GLP-1 Capsules, 3 / 6 Bottles
  var BM_3M = 67829089337543, BM_6M = 67829089370311;                 // BIOMEnd Butyrate, 3 / 6 Bottles: drink bag; drink bag + capsules bottle
  var GIFT_DRINK_PRODUCT = 15382883991751, GIFT_BIO_PRODUCT = 15382884024519, GIFT_CAPS_PRODUCT = 15390678745287;
  /* Sample pack gift (Brandon 2026-10-23): free with a 3-bottle capsule bundle where the page offers it
   * (ozzi-capsules-v2 sample_gift_3) and with the $59 monthly starter subscription (ozzi-single-offer gift_sample).
   * Zeroed by the same "Capsule bundle free gifts" discount, so this is what ties it to those lines. STARTER is
   * "Natural GLP-1 Supplement Capsules (Monthly)", the $118 / $59-a-month single-offer test product (capsules-c);
   * it also earns the travel case. A 1-bottle capsule subscription earns it too where the page offers it
   * (ozzi-capsules-v2 sample_gift_1, the A/B bundles arm, 2026-10-24).
   * Since 2026-10-27 the gift is the ORIGINAL free pack again, "Ozzi Sample Packs" (SAMPLE_ID above, SKU sample-1,
   * $20; Brandon: back to the original SKU and product), not the 3-stick "Ozzi Sample Pack (Free Gift)"
   * 15432171356359. So the drink orphan clean-up above must leave it alone when a capsule line earns it
   * (earnsSample), and the trim below still allows the one pack a drink order has always been allowed. */
  var GIFT_SAMPLE_PRODUCT = 8396098273479, STARTER = 68020946043079;
  /* Travel case (Brandon 2026-10-14, widened the same day to every plan): ONE per order with any OEA capsules or
   * BIOMEnd subscription line, 1, 3 or 6 bottles (not one-time), or a Day & Night Bundle subscription (2026-10-26). Its own automatic "Free travel case with any subscription" (Buy X Get Y,
   * one use per order) makes it free. Unlike the gifts above, this one is ADDED here too, so it lands in
   * the cart however the bundle got there. If Shopify does not make it free (discount off), it is taken
   * straight back out and not offered again this session, so the cart can never loop add/remove.
   */
  var GIFT_CASE_PRODUCT = 15410405671111, GIFT_CASE_VARIANT = 67915530961095, CASE_OFF_KEY = 'oz_case_off';
  function caseOff() { try { return sessionStorage.getItem(CASE_OFF_KEY) === '1'; } catch (e) { return false; } }
  function setCaseOff() { try { sessionStorage.setItem(CASE_OFF_KEY, '1'); } catch (e) {} }
  // Subscriptions only (Brandon 2026-10-14): a one-time line of any size does not earn the case.
  var CAPS_1M = 67792306110663, BM_1M = 67704054251719;
  /* Day & Night Bundle (Brandon 2026-10-26, sections/ozzi-day-night-label.liquid): a Skio static box, one variant per
   * flavor, holding a capsule bottle and a drink bag. Its subscription earns the travel case and the sample pack. */
  var DN_BOX = [68078936064199, 68078936096967, 68078936129735];
  // Lines that earn the sample pack. However many there are, an order gets ONE pack (Brandon 2026-10-27).
  function earnsSample(l) {
    return l.variant_id === CAPS_3M || (!!l.selling_plan_allocation &&
      (l.variant_id === STARTER || l.variant_id === CAPS_1M || DN_BOX.indexOf(l.variant_id) !== -1));
  }
  function qualifiesForCase(cart) {
    return (cart.items || []).some(function (l) {
      return (l.variant_id === CAPS_1M || l.variant_id === CAPS_3M || l.variant_id === CAPS_6M || l.variant_id === STARTER ||
        l.variant_id === BM_1M || l.variant_id === BM_3M || l.variant_id === BM_6M || DN_BOX.indexOf(l.variant_id) !== -1) &&
        !!l.selling_plan_allocation;
    });
  }
  function addCase() {
    return fetch(root() + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: GIFT_CASE_VARIANT, quantity: 1, properties: { _capsule_gift: 'case' } }] }),
    }).then(function (r) {
      // 422 once the 200 launch cases are gone (the case stops selling at zero): stop offering it.
      if (!r.ok) { setCaseOff(); return null; }
      return cartFor(null);
    })
      .then(function (cart) {
        if (!cart) return false;
        var line = (cart.items || []).filter(function (l) { return l.product_id === GIFT_CASE_PRODUCT; })[0];
        if (!line || line.final_line_price === 0) return true;
        setCaseOff();                                   // not free: undo, and stop offering it this session
        return postChange({ id: line.key, quantity: 0 }).then(function () { return false; });
      });
  }
  /* One per customer (Brandon 2026-10-07): the gifts move from the automatic discount to the
   * GIFT_CODE discount code, which Shopify limits to one use per customer. A gift line that is not
   * already free gets the code applied once; if the line is still priced after that, the prune below
   * drops it. Dormant while the automatic discount is on, since every gift line is then free.
   */
  var GIFT_CODE = 'FIRSTGIFT';
  function applyGiftCode(cart) {
    var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
    var priced = (cart.items || []).some(function (l) {
      return (l.product_id === GIFT_DRINK_PRODUCT || l.product_id === GIFT_BIO_PRODUCT || l.product_id === GIFT_CAPS_PRODUCT) && l.final_line_price > 0;
    });
    if (!priced || codes.some(function (c) { return String(c).toUpperCase() === GIFT_CODE; })) return cart;
    return fetch(root() + '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.concat(GIFT_CODE).join(',') }),
    }).then(function (r) { return r.ok ? r.json() : cart; }).catch(function () { return cart; });
  }

  var capsGiftPruning = null;
  function pruneCapsuleGifts(given) {
    if (capsGiftPruning) return capsGiftPruning;
    var wrote = false;
    capsGiftPruning = cartFor(given)
      .then(function (cart) {
        // It hands the same cart back untouched when there was no code to apply.
        return Promise.resolve(applyGiftCode(cart)).then(function (after) {
          if (after !== cart) wrote = true;
          return after;
        });
      })
      .then(function (cart) {
        var allowDrink = 0, allowBio = 0, allowCaps = 0, allowSample = 0, changes = [];
        var allowCase = qualifiesForCase(cart) ? 1 : 0, caseKept = 0;
        var drinkSample = false;
        (cart.items || []).forEach(function (l) {
          // Brandon 2026-10-24: the bundles arm's 1-bottle subscription gets the sample pack too (sample_gift_1).
          if (earnsSample(l)) allowSample += l.quantity;
          if (QUALIFYING_IDS.indexOf(l.variant_id) !== -1) drinkSample = true;
          if (l.variant_id === CAPS_3M) allowDrink += l.quantity;
          if (l.variant_id === CAPS_6M) { allowDrink += l.quantity; allowBio += l.quantity; }
          if (l.variant_id === BM_3M) allowDrink += l.quantity;
          if (l.variant_id === BM_6M) { allowDrink += l.quantity; allowCaps += l.quantity; }
          // Original-formula capsules: 2 bottles on a subscription earn one drink bag.
          if (l.variant_id === CAPS_V1 && l.selling_plan_allocation) allowDrink += Math.floor(l.quantity / 2);
        });
        // A drink order keeps the one free pack it has always been allowed (the SAMPLE offer, paused for now).
        // Never more than one pack per order, whatever earned it (Brandon 2026-10-27, after order #20167
        // came through with two); snippets/ozzi-sample-limit.liquid holds the same cap on every cart write.
        if (allowSample > 1 || drinkSample) allowSample = 1;
        (cart.items || []).forEach(function (l) {
          if (l.product_id === GIFT_CASE_PRODUCT) {
            var keepCase = l.final_line_price > 0 ? 0 : Math.min(l.quantity, allowCase - caseKept);
            caseKept += keepCase;
            if (keepCase !== l.quantity) changes.push({ id: l.key, quantity: keepCase });
            return;
          }
          var isDrink = l.product_id === GIFT_DRINK_PRODUCT, isBio = l.product_id === GIFT_BIO_PRODUCT, isCaps = l.product_id === GIFT_CAPS_PRODUCT,
            isSample = l.product_id === GIFT_SAMPLE_PRODUCT;
          if (!isDrink && !isBio && !isCaps && !isSample) return;
          var allow = isDrink ? allowDrink : (isBio ? allowBio : (isCaps ? allowCaps : allowSample));
          var keep = l.final_line_price > 0 ? 0 : Math.min(l.quantity, allow);
          if (isDrink) allowDrink -= keep; else if (isBio) allowBio -= keep; else if (isCaps) allowCaps -= keep; else allowSample -= keep;
          if (keep !== l.quantity) changes.push({ id: l.key, quantity: keep });
        });
        var needCase = allowCase > 0 && caseKept === 0 && !caseOff();
        if (!changes.length && !needCase) return null;
        var chain = Promise.resolve();
        changes.forEach(function (c) { chain = chain.then(function () { wrote = true; return postChange(c); }); });
        if (needCase) chain = chain.then(function () { return addCase(); }).then(function (added) { if (added) wrote = true; });
        return chain.then(function () {
          if (!wrote) return;
          if (leaving) return;
          if (document.querySelector('cart-items')) { window.location.reload(); return; }
          if (document.querySelector('cart-drawer')) return refreshDrawer();
        });
      })
      .catch(function (error) { console.error('[oz-cart] capsule gift cleanup failed', error); })
      .then(function () { capsGiftPruning = null; return wrote; });
    return capsGiftPruning;
  }

  /* ---------- before checkout ----------
   * Buy buttons go straight to checkout (snippets/ozzi-checkout.liquid), so there is no open drawer
   * for the three clean-ups above to finish behind. They run first instead, and only when the cart
   * holds a line one of them could act on: on an ordinary cart this costs nothing. They work from
   * the cart the button has just read, so a cart that is already right (the usual gift bundle)
   * costs no request either; once one of them writes, the rest read for themselves. Once the
   * shopper is leaving, the clean-ups skip the cart UI refresh; nobody is going to see it, and on
   * /cart it is a reload that would land on top of the way out.
   */
  var leaving = false;
  function holdsFreebie(cart) {
    return (cart.items || []).some(function (l) {
      return (l.variant_id || l.id) === SAMPLE_ID || isGiftLine(l) ||
        l.product_id === GIFT_DRINK_PRODUCT || l.product_id === GIFT_BIO_PRODUCT || l.product_id === GIFT_CAPS_PRODUCT ||
        l.product_id === GIFT_SAMPLE_PRODUCT || l.product_id === GIFT_CASE_PRODUCT;
    }) || qualifiesForCase(cart);
  }
  if (window.OzziCheckout) {
    window.OzziCheckout.before(function (cart) {
      if (!holdsFreebie(cart)) return false;
      leaving = true;
      var read = cart, wroteAny = false;
      function run(prune) {
        return function () {
          return prune(read).then(function (wrote) { if (wrote) { wroteAny = true; read = null; } });
        };
      }
      return run(pruneOrphanSample)()
        .then(run(pruneOrphanGift))
        .then(run(pruneCapsuleGifts))
        .then(function () { return wroteAny; });
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function () {
    // On load only bother on the cart page, where a stranded pack is actually visible. Everywhere
    // else this would cost every visitor a /cart.js round trip for nothing.
    if (/(^|\/)cart(\/|$)/.test(window.location.pathname)) { pruneOrphanSample(); pruneOrphanGift(); pruneCapsuleGifts(); }
    // The one exception: a promo bottle that is no longer free. The drawer flags it server-side
    // (snippets/cart-drawer.liquid), so it is taken out on whatever page the shopper lands on,
    // before it can be checked out at full price. No flag, no request.
    else if (document.querySelector('cart-drawer[data-oz-stale-gift]')) { pruneOrphanGift(); }

    // Catches removals wherever they happen: cart page, drawer, or the builder. Our own removal
    // publishes nothing, so this can't loop, and a second pass finds no sample and exits anyway.
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { pruneOrphanSample(); pruneOrphanGift(); pruneCapsuleGifts(); });
      }
    } catch (e) { /* theme without the pub/sub helpers */ }
  });
})();
